import { atomFamily } from "jotai/utils";
import { atom } from "jotai";
import { Edge } from "@xyflow/react";

export const allZapStepEdgesAtomFamily = atomFamily((zapNodeId) => {
  const allZapStepEdgesAtom = atom<Edge[]>([]);
  allZapStepEdgesAtom.debugLabel = `allZapStepEdgesAtomFamily(zapNodeId:${zapNodeId})`;
  return allZapStepEdgesAtom;
});
